import PropReferenceLabel from "../../../components/PropReferenceLabel";
import { useSelector } from "react-redux";
import { selectAllPropPresets } from "../../../app/slices/TrainingSlice";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";

import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";
import { FiBox } from "react-icons/fi";
import PropIcon from "../../../icons/PropIcon";
import { ReactNode, useMemo } from "react";

export default function NodeAllPropsDropdown(props: {
  label: string;
  selectedPropStateId: string;
  onClick: (propStateId: string) => void;
  accessory?: ReactNode;
}) {
  const allPropPresets = useSelector(selectAllPropPresets);
  const selectedPropPreset = allPropPresets.find(
    (prop) => prop.id === props.selectedPropStateId
  );
  // dropdown items
  const dropdownItems = allPropPresets.map((p) => (
    <PiCreatorDropdownItem
      text={p.name}
      icon={<ViewInArOutlinedIcon color="inherit" fontSize="inherit" />}
      onClick={() => props.onClick(p.id)}
    />
  ));

  const trigger = useMemo(
    () => (
      <div
        className={
          "flex items-center w-full h-full gap-[10px] px-[4px] text-creator-text-sub text-[20px]"
        }
      >
        <PropIcon size={20} />
        <div className={"my-auto font-normal text-[13px] text-creator-text"}>
          <PropReferenceLabel instanceId={props.selectedPropStateId} />
        </div>
      </div>
    ),
    [props.selectedPropStateId]
  );

  return (
    <div className="flex flex-col gap-[8px] noDrag nowheel">
      <div className="font-medium text-creator-text-sub text-[14px]">
        {props.label}
      </div>
      <div className="flex items-center gap-[8px]">
        <div className="flex-1 min-w-0">
          <PiCreatorDropdown
            style="square"
            label={undefined}
            trigger={trigger}
            items={dropdownItems as JSX.Element[]}
          />
        </div>
        {props.accessory && <div className="shrink-0">{props.accessory}</div>}
      </div>
    </div>
  );
}
